import { IeLynxObject } from "../../common/models/eLynxObject";


export const keys = {
    all: ["object"],
    attachments: (groupID: number, eLynxObject: IeLynxObject) => [
        ...keys.all,
        "attachments", {
            groupID,
            eLynxObject
        }
    ]
};
